import {Injectable} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent, HttpErrorResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {

  constructor(
    private toast: ToastrService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((e: HttpErrorResponse) => {
        if (e.status === 500) {

          if (e.error.message) {
            this.toast.error(e.error.message);
          } else {
            this.toast.error('Fehler bei der Serveranfrage');
          }

          return throwError(e);
        } else {
          return throwError(e);
        }
      })
    );
  }
}
